import { useState } from 'react';

import Breadcrumbs from './Breadcrumbs';
import UserTop from './User';
import TopWallet from './Wallet';

import LeftMenu from './LeftMenu';

function Header(params) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const currentSection = params.currentSection;
    const sectionPath = params.sectionPath;
    const subSection = params.subSection;
    const subSectionPath = params.subSectionPath;
    const subSectionOne = params.subSectionOne;
    const campaignId = params.campaignId;
    const extraIcon = params.extraIcon;
    const extraSection = params.extraSection;
    return (
        <>
            {/* // Menu Lateral */}
            <div
                className={`fixed z-40 top-0 left-0 h-screen bg-white transition-all duration-300 ease-out shadow-md ${
                    isMenuOpen ? 'w-80 shadow-xl' : 'w-16'
                }`}>
                <button
                    type="button"
                    onClick={() => setIsMenuOpen((prev) => !prev)}
                    className="absolute top-6 -right-3 z-50 flex h-7 w-7 items-center justify-center rounded-full border bg-white shadow-md transition hover:bg-gray-50 hover:shadow-lg"
                    aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-gray-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}>
                        {isMenuOpen ? (
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15 19l-7-7 7-7"
                            />
                        ) : (
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M9 5l7 7-7 7"
                            />
                        )}
                    </svg>
                </button>
                <img
                    src={
                        require(
                            `../../images/${process.env.REACT_APP_WL_NAME}/iso.svg`
                        ).default
                    }
                    className={`mt-4 ml-3 w-8 pl-1 opacity-25 ${
                        isMenuOpen ? 'hidden' : 'block'
                    }`}
                    alt={process.env.REACT_APP_WL_COMPANY_NAME}
                />
                <img
                    src={
                        require(
                            `../../images/${process.env.REACT_APP_WL_NAME}/logo-color.svg`
                        ).default
                    }
                    className={`mt-3 ml-1 h-12 ${
                        isMenuOpen ? 'block' : 'hidden'
                    }`}
                    alt={process.env.REACT_APP_WL_COMPANY_NAME}
                />
                <LeftMenu
                    isMenuOpen={isMenuOpen}
                    openMenu={() => setIsMenuOpen(true)}
                />
            </div>
            {/* // Menu Superior */}
            <div className="fixed z-30 top-0 left-0 bg-gray-100 bg-opacity-75 backdrop border w-full p-2 md:p-4 flex justify-between font-light">
                <Breadcrumbs
                    currentSection={currentSection}
                    sectionPath={sectionPath}
                    subSection={subSection}
                    subSectionPath={subSectionPath}
                    subSectionOne={subSectionOne}
                    campaignId={campaignId}
                    extraIcon={extraIcon}
                    extraSection={extraSection}
                />
                <div className="flex flex-nowrap justify-end items-center gap-2 text-xs">
                    <TopWallet />
                    <UserTop />
                </div>
            </div>
        </>
    );
}

export default Header;
